export default "__VITE_ASSET__C2F5Ec2X__"